export default class Address {
  static getAddressLines = (address) => {
    if (!address) return [];
    return [address.address, address.city + " " + address.province + " " + address.postal_code, address.country];
  };

  static getOneLineAddress = (address) => {
    if (!address) return "";
    return Address.getAddressLines(address)[0];
  };

  static getCustomerAddressLines = (address) => {
    if (!address) return [];

    const { contact_name, phone_number, address: addressString, province, postal_code, country } = address;

    return [`Contact: ${contact_name}`, `${addressString}, ${postal_code}, ${province}, ${country}`, phone_number];
  };

  static getLatestAddress(addresses = []) {
    return addresses.sort((a, b) => new Date(b?.created_at) - new Date(a?.created_at))[0];
  }
}
